<template>
  <div class="diff-text-editor">
    <EditorContent class="editor-content" :editor="editor" />
  </div>
</template>

<script setup lang="ts">
import { ShallowRef, watch } from 'vue'
import { Editor, EditorContent, useEditor } from '@tiptap/vue-3'
import StarterKit from '@tiptap/starter-kit'
import { Markdown } from 'tiptap-markdown'
import { Inserted } from './nodes/inserted'
import { Deleted } from './nodes/deleted'

interface Props {
  content: string
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'select:suggestion', suggestionId: string, event: MouseEvent): void
}>()

watch(
  () => props.content,
  newValue => {
    editor.value?.commands.setContent(newValue)
  }
)

const editor: ShallowRef<Editor> = useEditor({
  editable: false,
  content: props.content,
  extensions: [
    StarterKit.configure({
      orderedList: false,
      horizontalRule: false,
    }),
    Markdown.configure({
      tightLists: true,
      breaks: true,
    }),
    Inserted.configure({
      onMouseover: (suggestionId, event) => {
        emit('select:suggestion', suggestionId, event)
      },
    }),
    Deleted.configure({
      onMouseover: (suggestionId, event) => {
        emit('select:suggestion', suggestionId, event)
      },
    }),
  ],
})
</script>
